import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

const I18N_SKIP_SUPPORT_LINK_FALLBACKS = {
  RATE_NEGOTIATION_ADMIN:
    "https://support.clipboardhealth.com/hc/en-us/articles/11915602837655-Pay-Rate-Negotiations",
  RATE_NEGOTIATION_WORKPLACE:
    "https://support.clipboardhealth.com/hc/en-us/articles/11915602837655-Pay-Rate-Negotiations",
} as const;

const SUPPORT_LINK_FALLBACKS = I18N_SKIP_SUPPORT_LINK_FALLBACKS;

export type SupportLinkKey = keyof typeof SUPPORT_LINK_FALLBACKS;

/**
 * Resolves a support-article URL from the `support-links` LaunchDarkly flag, falling back to
 * {@link SUPPORT_LINK_FALLBACKS}.
 */
export function useSupportLink(key: SupportLinkKey): string {
  const supportLinks = useCbhFlag(CbhFeatureFlag.SUPPORT_LINKS, {
    defaultValue: SUPPORT_LINK_FALLBACKS,
  });

  return supportLinks?.[key] || SUPPORT_LINK_FALLBACKS[key];
}
